<template>
    <div class="md:py-1 rtb-header">
        <div class="business-logo invisible w-0 h-0">
            <img src="/images/aside-square-bw.png" alt="logo"/>
        </div>
        <!-- Off-canvas menu for mobile -->
        <div v-if="user && sidebarOpen" class="md:hidden">
            <div
                @click="sidebarOpen = false"
                v-show="sidebarOpen"
                class="fixed inset-0 z-30 transition-opacity ease-linear duration-500"
            >
                <!--<div class="absolute inset-0 bg-gray-600 opacity-75"></div>-->
            </div>
            <div class="fixed inset-0 flex z-40">
                <div
                    v-if="sidebarOpen && user"
                    class="flex flex-col max-w-xs w-full bg-white transform ease-in-out duration-500"
                    v-click-away="onClickAway"
                >
                    <div class="grid gap-2 p-6 overflow-y-auto mb-32">
                        <div class="close-and-lang flex justify-between items-center">
                            <div class="close cursor-pointer" @click="toggleSidebar(false)">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8824 14.0034L17.1854 19.3074C17.4668 19.5888 17.8485 19.7469 18.2464 19.7469C18.6444 19.7469 19.026 19.5888 19.3074 19.3074C19.5888 19.026 19.7469 18.6444 19.7469 18.2464C19.7469 17.8485 19.5888 17.4668 19.3074 17.1854L14.0024 11.8824L19.3064 6.57943C19.4457 6.4401 19.5561 6.2747 19.6315 6.09268C19.7068 5.91066 19.7456 5.71558 19.7455 5.51858C19.7455 5.32158 19.7066 5.12652 19.6312 4.94453C19.5558 4.76255 19.4452 4.5972 19.3059 4.45793C19.1666 4.31867 19.0012 4.20821 18.8192 4.13286C18.6371 4.05752 18.4421 4.01876 18.2451 4.01881C18.0481 4.01885 17.853 4.0577 17.671 4.13313C17.489 4.20856 17.3237 4.3191 17.1844 4.45843L11.8824 9.76143L6.57942 4.45843C6.44111 4.31511 6.27565 4.20076 6.09268 4.12206C5.90971 4.04336 5.7129 4.00189 5.51374 4.00006C5.31457 3.99824 5.11703 4.0361 4.93265 4.11143C4.74827 4.18677 4.58074 4.29807 4.43984 4.43884C4.29894 4.57961 4.18748 4.74704 4.11197 4.93134C4.03646 5.11565 3.99841 5.31315 4.00005 5.51232C4.00169 5.71149 4.04297 5.90834 4.1215 6.09138C4.20002 6.27443 4.31422 6.44 4.45742 6.57843L9.76242 11.8824L4.45842 17.1854C4.17702 17.4668 4.01894 17.8485 4.01894 18.2464C4.01894 18.6444 4.17702 19.026 4.45842 19.3074C4.73981 19.5888 5.12146 19.7469 5.51942 19.7469C5.91737 19.7469 6.29902 19.5888 6.58042 19.3074L11.8824 14.0024V14.0034Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="mid-line"></div>
                            <div class="language-switch">
                                <SwitchLang/>
                            </div>
                        </div>

                        <div class="user-profile border border-gray-300 rounded mb-1 p-2 cursor-pointer" @click="$router.push('/customer/profile')">
                            <div class="user-icon-name flex items-center gap-3">
                                <div class="image">
                                    <img class="w-10 h-10 rounded-full flex items-start justify-center"
                                         :src="user?.profile?.photo"
                                         alt="user">
                                </div>
                                <div class="user-name-email grid">
                                    <div class="name font-bold text-base">
                                        <p>{{ user?.name }}</p>
                                    </div>
                                    <div class="email">
                                        <p>{{ user?.email ?? 'example@test.com' }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="menu-item my-profile flex gap-5 items-center cursor-pointer"
                             @click="$router.push('/provider/profile')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.44444 7.55556C8.44444 6.61256 8.81905 5.70819 9.48584 5.0414C10.1526 4.3746 11.057 4 12 4C12.943 4 13.8474 4.3746 14.5142 5.0414C15.181 5.70819 15.5556 6.61256 15.5556 7.55556C15.5556 8.49855 15.181 9.40292 14.5142 10.0697C13.8474 10.7365 12.943 11.1111 12 11.1111C11.057 11.1111 10.1526 10.7365 9.48584 10.0697C8.81905 9.40292 8.44444 8.49855 8.44444 7.55556ZM8.44444 12.8889C7.2657 12.8889 6.13524 13.3571 5.30175 14.1906C4.46825 15.0241 4 16.1546 4 17.3333C4 18.0406 4.28095 18.7189 4.78105 19.219C5.28115 19.719 5.95942 20 6.66667 20H17.3333C18.0406 20 18.7189 19.719 19.219 19.219C19.719 18.7189 20 18.0406 20 17.3333C20 16.1546 19.5317 15.0241 18.6983 14.1906C17.8648 13.3571 16.7343 12.8889 15.5556 12.8889H8.44444Z" fill="#1A1A1A"/>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>প্রোফাইল</p>
                            </div>
                        </div>

                        <div class="menu-item my-profile flex gap-5 items-center cursor-pointer"
                             @click="$router.push('/provider/car/index')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M20.2606 9.83112C20.2479 9.81691 20.2371 9.80306 20.2221 9.78922L19.5613 9.16922C20.1093 9.04836 20.6993 8.60198 20.6993 8.14399C20.6993 7.61043 19.9377 7.4211 19.2876 7.4211C18.608 7.4211 18.5291 7.87384 18.521 8.19376L16.816 6.59568C16.4696 6.26229 15.8126 6 15.3215 6H8.67867C8.18796 6 7.53137 6.26229 7.1846 6.59568L5.48 8.19376C5.47115 7.87384 5.39225 7.4211 4.71334 7.4211C4.06252 7.4211 3.30125 7.61043 3.30125 8.14399C3.30125 8.60198 3.89164 9.04836 4.4397 9.16922L3.77887 9.78922C3.76386 9.80306 3.75347 9.81691 3.74039 9.83112C3.03338 10.4186 2.57153 11.5082 2.57153 12.2988V14.6482C2.57153 15.2184 2.80284 15.7359 3.17655 16.1217V17.0328C3.17655 17.5656 3.63532 18 4.19954 18H5.43651C6.00073 18 6.45912 17.5663 6.45912 17.0328V16.7997H17.5415V17.0328C17.5415 17.5663 17.9995 18 18.5645 18H19.8011C20.3657 18 20.8237 17.5656 20.8237 17.0328V16.1217C21.212 15.7239 21.4285 15.1965 21.4287 14.6482V12.2988C21.4294 11.5082 20.9676 10.4186 20.2606 9.83112ZM7.81078 7.30585C8.05056 7.11166 8.46968 6.96424 8.67867 6.96424H15.3223C15.5313 6.96424 15.9504 7.11166 16.1902 7.30585L18.4259 9.41243H5.57545L7.81078 7.30585ZM3.33858 11.9433C3.33858 11.3648 3.80428 10.8953 4.37927 10.8953C4.95389 10.8953 6.83167 11.9669 6.83167 12.5454C6.83167 13.1238 4.95389 12.9899 4.37927 12.9899C3.80428 12.9899 3.33858 12.5222 3.33858 11.9433ZM6.4595 15.7696H6.06308L4.8873 15.7714C4.56093 15.6727 4.33078 15.5574 4.16798 15.4336C4.09435 15.3784 4.02883 15.3137 3.97323 15.2412C3.92715 15.1821 3.89032 15.1167 3.86393 15.0471C3.71768 14.6452 4.0198 14.2759 4.0198 14.2759H6.02652L7.36433 15.7688L6.4595 15.7696ZM14.8859 15.7703H9.11511C8.82614 15.7702 8.54902 15.6586 8.34465 15.46C8.14027 15.2614 8.02536 14.992 8.02516 14.711H15.9758C15.9757 14.992 15.8608 15.2614 15.6564 15.4601C15.4521 15.6587 15.1749 15.7703 14.8859 15.7703ZM15.1391 13.9882H8.86187C8.20758 13.9882 7.67646 13.2039 7.67646 12.2367H16.3245C16.3245 13.2043 15.7934 13.9882 15.1391 13.9882ZM20.1374 15.0478C20.1108 15.1173 20.0739 15.1826 20.0277 15.2416C19.9724 15.3142 19.9068 15.379 19.833 15.4339C19.6706 15.5578 19.44 15.6738 19.1137 15.7718L17.9379 15.7699H16.6359L17.9745 14.277H19.9808C19.9808 14.2766 20.2833 14.6452 20.1374 15.0478ZM19.6217 12.9899C19.0475 12.9899 17.1697 13.1231 17.1697 12.5454C17.1697 11.9676 19.0475 10.8953 19.6217 10.8953C20.1967 10.8953 20.6624 11.3648 20.6624 11.9433C20.6624 12.5214 20.1967 12.9899 19.6217 12.9899Z" fill="#1A1A1A"/>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>কার</p>
                            </div>
                        </div>

                        <div class="menu-item my-profile flex gap-5 items-center cursor-pointer"
                             @click="$router.push('/my-wallet')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M7.21606 5.4264L14.4083 3.38597L14.0274 2.5858C13.7782 2.06569 13.1704 1.85091 12.67 2.10991L6.23144 5.4264H7.21606ZM16.6409 3.44493C16.5518 3.44493 16.4626 3.45756 16.3735 3.48283L14.6838 3.96293L9.52365 5.4264H17.9335L17.6174 4.22193C17.4959 3.75236 17.0866 3.44493 16.6409 3.44493ZM18.989 6.1634H4.01502C3.69491 6.1634 3.40925 6.31711 3.22286 6.55927C3.13777 6.67087 3.07294 6.79932 3.03647 6.9404C3.01418 7.02884 3 7.12149 3 7.21625V18.9471C3 19.5283 3.45382 20 4.01299 20H18.987C19.5462 20 20 19.5283 20 18.9471V16.0097H13.9889C13.0387 16.0097 12.2668 15.2074 12.2668 14.2198V11.8783C12.2668 11.394 12.4532 10.9539 12.7551 10.6317C13.0225 10.3453 13.3811 10.1516 13.7823 10.1032C13.8491 10.0948 13.918 10.0905 13.9869 10.0905H20V7.21625C20.002 6.63507 19.5482 6.1634 18.989 6.1634Z" fill="#1A1A1A"/>
                                    <path d="M20.6724 11.248C20.572 11.1609 20.4534 11.0946 20.3208 11.0511C20.2183 11.0189 20.1098 11 19.9952 11H14.0048C13.4501 11 13 11.424 13 11.9465V14.0535C13 14.576 13.4501 15 14.0048 15H19.9952C20.1098 15 20.2183 14.9811 20.3208 14.9489C20.4534 14.9072 20.572 14.8391 20.6724 14.752C20.8734 14.5797 21 14.3299 21 14.0535V11.9465C21 11.6701 20.8734 11.4202 20.6724 11.248ZM16.1027 13.1883C16.1027 13.4496 15.8777 13.6616 15.6004 13.6616H15.2668C14.9895 13.6616 14.7644 13.4496 14.7644 13.1883V12.8741C14.7644 12.7227 14.8387 12.5882 14.9573 12.503C15.0437 12.4406 15.1502 12.4008 15.2668 12.4008H15.6004C15.8777 12.4008 16.1027 12.6128 16.1027 12.8741V13.1883Z" fill="#1A1A1A"/>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>পেমেন্ট</p>
                            </div>
                        </div>

                        <div class="menu-item my-profile flex gap-5 items-center cursor-pointer"
                             @click="$router.push('/referral')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M7.75513 7.72681C8.94599 7.72681 9.91138 6.76142 9.91138 5.57056C9.91138 4.37969 8.94599 3.41431 7.75513 3.41431C6.56426 3.41431 5.59888 4.37969 5.59888 5.57056C5.59888 6.76142 6.56426 7.72681 7.75513 7.72681Z" fill="black"/>
                                    <path d="M9.28689 8.04077C8.82665 8.32543 8.29618 8.47622 7.75502 8.47622C7.21385 8.47622 6.68339 8.32543 6.22314 8.04077C5.52724 8.34079 4.93444 8.83805 4.51794 9.47114C4.10143 10.1042 3.87944 10.8455 3.87939 11.6033V11.8508H11.6306V11.6033C11.6313 11.094 11.5313 10.5896 11.3363 10.1192C11.1413 9.64872 10.8552 9.22148 10.4944 8.86202C10.1494 8.51702 9.74064 8.23577 9.28689 8.04077Z" fill="black"/>
                                    <path d="M16.2461 16.4597C17.437 16.4597 18.4023 15.4943 18.4023 14.3035C18.4023 13.1126 17.437 12.1472 16.2461 12.1472C15.0552 12.1472 14.0898 13.1126 14.0898 14.3035C14.0898 15.4943 15.0552 16.4597 16.2461 16.4597Z" fill="black"/>
                                    <path d="M17.777 16.7756C17.317 17.0593 16.7874 17.2098 16.247 17.2106C15.6845 17.2106 15.1595 17.0493 14.717 16.7756C14.2595 16.9706 13.8507 17.2518 13.5057 17.5931C13.1453 17.9528 12.8594 18.3801 12.6644 18.8505C12.4694 19.3209 12.3692 19.8251 12.3695 20.3343V20.5856H20.1207V20.3343C20.1207 18.7368 19.1532 17.3681 17.777 16.7756ZM8.4605 15.4736H9.63087L7.34712 12.741L5.06787 15.4736H6.212C6.212 15.4736 6.81912 19.1036 11.5231 19.5086C9.42425 18.4087 8.4605 15.4736 8.4605 15.4736Z" fill="black"/>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>রেফার করুন</p>
                            </div>
                        </div>

                        <div class="menu-item contact flex gap-5 items-center cursor-pointer"
                             @click="$router.push('/contact')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M20.9915 12.1821C21.0202 12.8741 20.7756 13.5494 20.3114 14.0597C19.8472 14.5701 19.2013 14.8738 18.5154 14.9044C18.4753 14.9062 18.4353 14.9072 18.3953 14.9072C18.213 14.907 18.0313 14.8871 17.8533 14.8478C17.325 15.6706 16.6324 16.3731 15.8196 16.9104C15.0068 17.4476 14.0918 17.8079 13.1331 17.968C13.0197 18.304 12.7935 18.5896 12.4935 18.7752C12.1936 18.9608 11.8388 19.0349 11.4904 18.9847C11.1421 18.9344 10.8221 18.7629 10.5858 18.4999C10.3495 18.2369 10.2117 17.8988 10.1962 17.5442C10.1808 17.1896 10.2886 16.8406 10.5011 16.5577C10.7137 16.2748 11.0175 16.0756 11.3602 15.9947C11.7028 15.9138 12.0627 15.9562 12.3776 16.1146C12.6925 16.273 12.9427 16.5374 13.0849 16.8621C14.4346 16.6103 15.6539 15.8887 16.5303 14.823C17.4068 13.7574 17.8847 12.4153 17.8809 11.0307C17.8809 7.75953 15.2427 5.09826 12 5.09826C8.75727 5.09826 6.11913 7.75953 6.11913 11.0307C6.11896 12.0422 6.37522 13.0369 6.86356 13.9204C6.88011 13.9495 6.89254 13.9809 6.90047 14.0135C6.94764 14.1458 6.9426 14.2913 6.88639 14.4199C6.83018 14.5485 6.7271 14.6504 6.5985 14.7044C6.28359 14.8381 5.94536 14.907 5.6037 14.9069C5.56349 14.9069 5.5232 14.906 5.48282 14.9041C4.79718 14.8732 4.15167 14.5692 3.68784 14.0589C3.224 13.5486 2.9797 12.8736 3.0085 12.1819C3.02008 11.906 3.01362 11.6599 3.0073 11.4219C3.00142 11.1978 2.99529 10.9661 3.00538 10.7243C3.03549 10.0489 3.3235 9.41142 3.80909 8.94542C4.29468 8.47943 4.94017 8.22104 5.61038 8.22439C6.68661 5.74042 9.14539 4 12 4C14.8546 4 17.3134 5.74042 18.3897 8.22443C19.0599 8.22057 19.7056 8.47873 20.1913 8.94474C20.677 9.41075 20.9649 10.0484 20.9946 10.7239C21.0047 10.9661 20.9986 11.1978 20.9927 11.4218C20.9864 11.6599 20.9799 11.9061 20.9915 12.1821ZM16.5655 11.0307C16.5653 11.7363 16.4043 12.4324 16.0952 13.0653C15.7861 13.6982 15.337 14.2511 14.7825 14.6812C14.2281 15.1113 13.5831 15.4072 12.8974 15.5462C12.2116 15.6851 11.5034 15.6632 10.8273 15.4823L8.97937 16.5589C8.88613 16.6132 8.77901 16.6384 8.67157 16.6313C8.56413 16.6242 8.46118 16.5851 8.37576 16.519C8.29034 16.4529 8.22627 16.3627 8.19166 16.2598C8.15706 16.157 8.15346 16.0461 8.18134 15.9412L8.65362 14.1639C7.87149 13.3111 7.43631 12.1925 7.43466 11.0307C7.43466 8.4905 9.48257 6.42408 12 6.42408C14.5174 6.42408 16.5655 8.4905 16.5655 11.0307ZM10.7307 11.0307C10.7307 10.8851 10.6734 10.7454 10.5713 10.6424C10.4692 10.5394 10.3308 10.4816 10.1864 10.4816H10.1855C10.0779 10.4818 9.97271 10.5142 9.88333 10.5746C9.79394 10.6351 9.72433 10.7209 9.68328 10.8213C9.64224 10.9216 9.6316 11.032 9.65272 11.1385C9.67384 11.2449 9.72577 11.3427 9.80194 11.4194C9.87811 11.4961 9.9751 11.5483 10.0807 11.5694C10.1862 11.5905 10.2956 11.5795 10.395 11.5379C10.4945 11.4963 10.5794 11.426 10.6392 11.3357C10.699 11.2454 10.7309 11.1393 10.7309 11.0307H10.7307ZM12.5445 11.0307C12.5444 11.0127 12.5435 10.9948 12.5416 10.9769C12.5398 10.9589 12.5372 10.9411 12.5336 10.9234C12.5304 10.9058 12.526 10.8885 12.5205 10.8715C12.5155 10.8543 12.5093 10.8374 12.5028 10.8206C12.4962 10.8037 12.4883 10.788 12.4799 10.7722C12.4716 10.7564 12.4625 10.741 12.4527 10.7261C12.4428 10.7111 12.4321 10.6965 12.4207 10.6826C12.4095 10.6686 12.3975 10.6552 12.3848 10.6427C12.3725 10.6298 12.3591 10.6178 12.3453 10.606C12.3314 10.5951 12.3169 10.5841 12.302 10.5742C12.2873 10.5643 12.272 10.5551 12.2564 10.5467C12.2407 10.5383 12.2244 10.5306 12.2081 10.5237C12.1917 10.5168 12.175 10.5108 12.158 10.5057C12.1241 10.4947 12.089 10.4876 12.0535 10.4845C12.0002 10.4793 11.9464 10.4819 11.8938 10.4922C11.8763 10.4958 11.859 10.5003 11.842 10.5057C11.8249 10.5108 11.8082 10.5168 11.7919 10.5237C11.7755 10.5306 11.7592 10.5383 11.7436 10.5467C11.728 10.5552 11.7128 10.5643 11.6978 10.5742C11.6681 10.5941 11.6403 10.6171 11.6151 10.6427C11.6024 10.6552 11.5904 10.6686 11.5792 10.6826C11.5679 10.6965 11.5574 10.7111 11.5476 10.7261C11.5377 10.741 11.5285 10.7564 11.5201 10.7722C11.5117 10.7879 11.5042 10.8041 11.4975 10.8206C11.4906 10.8372 11.4846 10.8542 11.4794 10.8715C11.4743 10.8883 11.47 10.9059 11.4663 10.9234C11.4628 10.9411 11.4601 10.9589 11.4583 10.9769C11.4566 10.9948 11.4558 11.0128 11.4558 11.0307C11.4558 11.0486 11.4566 11.0669 11.4583 11.0849C11.4601 11.1027 11.4628 11.1204 11.4663 11.138C11.47 11.1555 11.4743 11.1731 11.4794 11.1903C11.4846 11.2075 11.4906 11.2243 11.4975 11.2408C11.5042 11.2575 11.5117 11.2737 11.5201 11.2895C11.5284 11.3053 11.5378 11.3206 11.5476 11.3357C11.5574 11.3506 11.5679 11.365 11.5792 11.3789C11.5905 11.3929 11.6025 11.4063 11.6151 11.4191C11.6278 11.4316 11.6409 11.444 11.6551 11.4554C11.6687 11.4668 11.683 11.4774 11.6978 11.4872C11.7128 11.4971 11.728 11.5066 11.7436 11.515C11.7751 11.5316 11.808 11.5453 11.842 11.556C11.859 11.5612 11.8764 11.5656 11.8938 11.5692C11.9288 11.5764 11.9644 11.58 12.0001 11.5798C12.1443 11.5795 12.2826 11.5217 12.3848 11.4191C12.4099 11.3934 12.4326 11.3655 12.4527 11.3357C12.4625 11.3206 12.4716 11.3053 12.4799 11.2895C12.4883 11.2738 12.4959 11.2573 12.5028 11.2408C12.5097 11.2244 12.5155 11.2072 12.5205 11.1903C12.5259 11.1732 12.5303 11.1557 12.5336 11.138C12.5372 11.1204 12.5398 11.1027 12.5416 11.0849C12.5434 11.0669 12.5444 11.0488 12.5444 11.0306L12.5445 11.0307ZM14.359 11.0307C14.359 10.8851 14.3016 10.7454 14.1995 10.6424C14.0975 10.5394 13.959 10.4816 13.8146 10.4816H13.8136C13.706 10.4818 13.6008 10.5142 13.5114 10.5746C13.4221 10.6351 13.3525 10.7209 13.3114 10.8213C13.2704 10.9217 13.2597 11.032 13.2809 11.1385C13.302 11.2449 13.3539 11.3427 13.4301 11.4194C13.5063 11.4961 13.6033 11.5483 13.7088 11.5694C13.8144 11.5905 13.9238 11.5795 14.0232 11.5379C14.1226 11.4963 14.2076 11.426 14.2673 11.3357C14.3271 11.2454 14.359 11.1393 14.359 11.0307Z" fill="#1A1A1A"/>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>যোগাযোগ</p>
                            </div>
                        </div>

                        <div class="menu-item help-line flex gap-5 items-center cursor-pointer"
                             @click="$router.push('/help')">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path d="M19.0787 12.3089L18.7557 12.1134C18.3713 11.8814 18.1416 11.4648 18.1416 11C18.1416 10.5352 18.3713 10.1186 18.7557 9.88657L19.0787 9.69114C19.2883 9.56457 19.472 9.39601 19.6193 9.19509C19.7666 8.99417 19.8747 8.76483 19.9373 8.52018C19.9999 8.27553 20.0158 8.02036 19.9842 7.76925C19.9526 7.51814 19.874 7.27602 19.753 7.05671L19.1389 5.94329C18.8942 5.50074 18.4918 5.17787 18.02 5.04554C17.5482 4.9132 17.0455 4.98222 16.6223 5.23743L16.2993 5.43221C16.113 5.54653 15.9011 5.60679 15.6852 5.60679C15.4693 5.60679 15.2573 5.54653 15.0711 5.43221C14.8835 5.32038 14.7278 5.15831 14.6199 4.96263C14.5119 4.76695 14.4557 4.54473 14.457 4.31879V3.92857C14.457 2.86529 13.6304 2 12.6147 2H11.3864C10.3707 2 9.54414 2.86529 9.54414 3.92857V4.31943C9.5454 4.54537 9.48918 4.7676 9.38125 4.96327C9.27333 5.15895 9.11759 5.32103 8.93004 5.43286C8.74374 5.54698 8.53179 5.60712 8.31594 5.60712C8.10009 5.60712 7.88813 5.54698 7.70183 5.43286L7.37882 5.23743C6.95543 4.98236 6.45271 4.91343 5.98085 5.04574C5.509 5.17806 5.1065 5.50082 4.86161 5.94329L4.24751 7.05671C4.12638 7.276 4.04774 7.51813 4.01608 7.76925C3.98441 8.02038 4.00035 8.27558 4.06297 8.52025C4.1256 8.76492 4.23368 8.99427 4.38104 9.19519C4.52841 9.3961 4.71216 9.56463 4.92179 9.69114L5.24542 9.88657C5.62985 10.1186 5.85953 10.5352 5.85953 11C5.85953 11.4648 5.62985 11.8814 5.24542 12.1134L4.92241 12.3089C4.71277 12.4354 4.52902 12.6039 4.38166 12.8048C4.23429 13.0057 4.12621 13.2351 4.06359 13.4798C4.00096 13.7244 3.98503 13.9796 4.01669 14.2307C4.04835 14.4819 4.127 14.724 4.24812 14.9433L4.86222 16.0567C5.107 16.4991 5.50938 16.8219 5.98114 16.9542C6.4529 17.0865 6.95553 17.0176 7.37882 16.7626L7.70183 16.5678C7.88807 16.4535 8.10005 16.3932 8.31594 16.3932C8.53182 16.3932 8.74381 16.4535 8.93004 16.5678C9.11759 16.6796 9.27333 16.8417 9.38125 17.0374C9.48918 17.233 9.5454 17.4553 9.54414 17.6812V18.0714C9.54414 19.1347 10.3707 20 11.3864 20H12.6147C13.6304 20 14.457 19.1347 14.457 18.0714V17.6806C14.457 17.2158 14.6866 16.7999 15.0711 16.5671C15.2574 16.453 15.4693 16.3929 15.6852 16.3929C15.901 16.3929 16.113 16.453 16.2993 16.5671L16.6223 16.7626C17.0456 17.0174 17.5482 17.0863 18.0199 16.954C18.4916 16.8216 18.894 16.499 19.1389 16.0567L19.753 14.9433C19.8741 14.724 19.9527 14.4819 19.9844 14.2307C20.0161 13.9796 20.0001 13.7244 19.9375 13.4798C19.8749 13.2351 19.7668 13.0057 19.6194 12.8048C19.4721 12.6039 19.2883 12.4354 19.0787 12.3089ZM12.0006 14.2143C10.3075 14.2143 8.93004 12.7724 8.93004 11C8.93004 9.22764 10.3075 7.78571 12.0006 7.78571C13.6936 7.78571 15.0711 9.22764 15.0711 11C15.0711 12.7724 13.6936 14.2143 12.0006 14.2143Z" fill="#1A1A1A"/>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>সেটিংস</p>
                            </div>
                        </div>

                        <div class="menu-item help-line flex gap-5 items-center cursor-pointer"
                             v-if="user"
                             @click="logOut()"
                        >
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <g clip-path="url(#clip0_1068_3761)">
                                        <mask id="mask0_1068_3761" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                            <path d="M0 0H24V24H0V0Z" fill="white"/>
                                        </mask>
                                        <g mask="url(#mask0_1068_3761)">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M8.06318 6.54737C8.06318 4.95579 8.06318 4.16 8.3612 3.55179C8.62332 3.01704 9.04158 2.58227 9.55602 2.30979C10.1411 2 10.9067 2 12.4378 2H14.6251C16.1562 2 16.9218 2 17.5069 2.30979C18.0214 2.58227 18.4396 3.01704 18.7017 3.55179C18.9998 4.16 18.9998 4.95579 18.9998 6.54737V15.4526C18.9998 17.0442 18.9998 17.84 18.7017 18.4482C18.4396 18.983 18.0214 19.4177 17.5069 19.6902C16.9218 20 16.1562 20 14.6251 20H12.4378C10.9067 20 10.1411 20 9.55602 19.6902C9.04158 19.4177 8.62332 18.983 8.3612 18.4482C8.06318 17.84 8.06318 17.0442 8.06318 15.4526V14.0789H11.7087C12.4943 14.0789 13.2477 13.7546 13.8031 13.1771C14.3586 12.5997 14.6707 11.8166 14.6707 11C14.6707 10.1834 14.3586 9.40027 13.8031 8.82286C13.2477 8.24544 12.4943 7.92105 11.7087 7.92105H8.06318V6.54737ZM5.679 8.99537C5.7848 8.88539 5.86873 8.75483 5.92599 8.61113C5.98325 8.46744 6.01272 8.31343 6.01272 8.1579C6.01272 8.00236 5.98325 7.84835 5.92599 7.70466C5.86873 7.56096 5.7848 7.4304 5.679 7.32042C5.5732 7.21044 5.4476 7.1232 5.30936 7.06368C5.17113 7.00416 5.02297 6.97353 4.87334 6.97353C4.72372 6.97353 4.57556 7.00416 4.43732 7.06368C4.29908 7.1232 4.17348 7.21044 4.06768 7.32042L1.33353 10.1625C1.22772 10.2725 1.14377 10.4031 1.0865 10.5468C1.02923 10.6904 0.999756 10.8445 0.999756 11C0.999756 11.1555 1.02923 11.3096 1.0865 11.4532C1.14377 11.5969 1.22772 11.7275 1.33353 11.8375L4.06768 14.6796C4.28135 14.9017 4.57116 15.0265 4.87334 15.0265C5.17552 15.0265 5.46533 14.9017 5.679 14.6796C5.89268 14.4575 6.01272 14.1562 6.01272 13.8421C6.01272 13.528 5.89268 13.2267 5.679 13.0046L4.88975 12.1842H11.7087C12.0108 12.1842 12.3006 12.0594 12.5143 11.8374C12.7279 11.6153 12.8479 11.3141 12.8479 11C12.8479 10.6859 12.7279 10.3847 12.5143 10.1626C12.3006 9.94055 12.0108 9.81579 11.7087 9.81579H4.88975L5.679 8.99537Z" fill="#1A1A1A"/>
                                        </g>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_1068_3761">
                                            <rect width="24" height="24" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div class="title text-sm font-semibold">
                                <p>লগ আউট</p>
                            </div>
                        </div>

<!--                        <div
                            class="logout-rtb h-10 w-4/5  px-5 flex gap-4 items-center justify-center absolute left-0 right-0 bottom-5 mx-auto cursor-pointer"
                            v-if="user"
                            @click="logOut()"
                        >
                            <span class="text-white text-sm font-semibold">লগ আউট</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19"
                                 fill="none">
                                <path
                                    d="M18.4412 9.49989H8.38235M16.3235 12.6764L19.5 9.49989L16.3235 6.32341M11.0294 4.20577V3.14694C11.0294 2.58531 10.8063 2.04668 10.4092 1.64954C10.012 1.25241 9.4734 1.0293 8.91177 1.0293H3.61765C3.05601 1.0293 2.51738 1.25241 2.12024 1.64954C1.72311 2.04668 1.5 2.58531 1.5 3.14694V15.8528C1.5 16.4145 1.72311 16.9531 2.12024 17.3502C2.51738 17.7474 3.05601 17.9705 3.61765 17.9705H8.91177C9.4734 17.9705 10.012 17.7474 10.4092 17.3502C10.8063 16.9531 11.0294 16.4145 11.0294 15.8528V14.794"
                                    stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </div>-->
                    </div>
<!--                    <div class="absolute top-0 right-0 -mr-14 p-1">
                        <button
                            v-show="sidebarOpen"
                            @click="toggleSidebar(false)"
                            class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600"
                        >
                            <svg
                                class="h-6 w-6 text-black"
                                stroke="currentColor"
                                fill="none"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M6 18L18 6M6 6l12 12"
                                />
                            </svg>
                        </button>
                    </div>
                    <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto relative">
                        <div class="flex-shrink-0 flex items-center px-4">
                            <router-link to="/">
                                <img
                                    class="rtb-logo inline w-48"
                                    src="/images/aside-square-black.png"
                                    alt="rtb-logo"
                                />
                            </router-link>
                        </div>
                        <div class="user-lang flex justify-between p-4 mt-4">
                            <div class="user text-black">
                                <span v-if="!user">
                                  <router-link to="/signin">{{ $t("card.signIn") }}</router-link>
                                </span>
                                <span class="mdi mdi-account-outline text-base hover:text-red-600" v-else>
                                   <router-link to="/provider/profile">{{ user.name }}</router-link>
                                </span>
                            </div>
                            <div class="language-switch">
                                <SwitchLang/>
                            </div>
                        </div>
                        <nav class="px-2">
                            <button
                                :class="mobileNav"
                                v-if="user"
                                class="mdi mdi-account items-center flex gap-1"
                            >
                                <router-link to="/provider/profile">প্রোফাইল</router-link>
                            </button>

                            <button
                                :class="mobileNav"
                                v-if="user"
                                class="mdi mdi-car items-center flex gap-1"
                            >
                                <router-link to="/provider/car/index"> কার</router-link>
                            </button>

                            <button
                                :class="mobileNav"
                                v-if="user"
                                class="mdi mdi-cash-multiple items-center flex gap-1"
                            >
                                <router-link to="my-wallet"> পেমেন্ট</router-link>
                            </button>

                            <button
                                :class="mobileNav"
                                class="mdi mdi-help-box items-center flex gap-1"
                            >
                                <router-link to="/help"> হেল্প</router-link>
                            </button>
                            <div class="contact-us pl-2 mt-1">
                                <p class="pl-l">যোগাযোগ</p>
                                <ul>
                                    <li class="mt-5"><span class="mdi mdi-whatsapp"></span> <a
                                        href="https://wa.me/1871955556">WhatsApp</a></li>
                                    <li class="mt-5"><span class="mdi mdi-phone"></span><a href="tel:09638009008">
                                        09638009008</a></li>
                                </ul>
                            </div>
                        </nav>

                        <div
                            class="logout-rtb border-t border-black cursor-pointer px-4 text-red-500 absolute bg-white flex justify-center items-center w-full bottom-12 py-4"
                            v-if="user"
                            @click="logOut()"
                        >
                            <span class="mdi mdi-logout mr-2.5 text-xl text-black"></span>
                            <span class="" v-if="!isLoggingOut">লগআউট</span>
                            <span class="" v-else>লগআউট হচ্ছে</span>
                        </div>
                    </div>-->
                </div>
                <div class="flex-shrink-0 w-24" @click="sidebarOpen = false">
                    <!-- Force sidebar to shrink to fit close icon -->
                </div>
            </div>
        </div>
        <!-- Off-canvas menu for mobile -->
        <!-- Menubar for desktop -->
        <div class="max-width mx-auto py-4 hidden md:block">
            <div class="grid grid-cols-5">
                <div class="flex col-span-2 justify-start items-center">
                    <router-link to="/">
                        <img class="w-40" src="/images/aside-square-bw.png" alt="returntripbd"/>
                    </router-link>
                </div>

                <div class="col-span-3 flex justify-end items-center">
<!--                    <SwitchLang class="px-3"/>

                    <router-link to="/" :class="navClass">
                        {{ $t("menu.home") }}
                    </router-link>-->

                    <!--<button
                        :class="navClass"
                        @click="setDialogComponent('TripCreateForm')"
                        v-if="user"
                      >
                        {{ $t("menu.createTrip") }}
                      </button>-->
<!--                    <router-link
                        v-for="(menu, i) in menus"
                        :key="i"
                        :to="{ name: menu.link }"
                        :class="navClass"
                    >
                        {{ menu.name }}
                    </router-link>-->
                    <!--<div
                        v-if="user"
                        @click="viewNotification()"
                        :class="navClass"
                        class="relative flex justify-center cursor-pointer"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-bell"
                            :class="
                notifications.length > 0
                  ? 'text-gray-700 bg-red-400 p-1 rounded-full'
                  : ''
              "
                        >
                            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                            <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                        </svg>
                        <sup
                            v-if="notifications.length > 0"
                            class="count text-gray-700 text-sm mt-2 -ml-2"
                        >
                            {{ notifications.length > 9 ? "9+" : notifications.length }}
                        </sup>
                    </div>-->

                    <!--<div
                        class="flex mr-3 items-center relative signin-signup-wrapper"
                        v-if="!user"
                    >
                        <button
                            @click="$router.push('/signup')"
                            class="text-primary ml-1 py-1 px-3 rounded header-signin-signup border-solid border-2"
                        >
                            {{ $t("card.signIn") }}
                        </button>
                        <div class="absolute text-sm text-gray-700 flex signup-section">
                            New User?
                            <span
                                class="signup colored-primary cursor-pointer"
                                @click="$router.push('/signup')"
                            >
                                {{ $t("card.signUp") }}</span
                            >
                        </div>
                    </div>-->

                    <div class="relative" v-if="user">
                        <AccountDropdown
                            @onClickAccountDropdown="onClickAccountDropdown"
                            :userType="userType"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- Menubar for desktop -->
        <!-- Hamburger -->
        <div
            class="md:hidden mobile-header h-16 px-4 flex items-center"
            :class="user ? 'justify-between mobile-header-bg-black' : 'justify-start mobile-header-bg-white'"
        >
            <!--<div v-if="!user">
                <div
                    v-if="$route.name !== 'BeforeSignin'"
                    @click="$router.go(-1)"
                    class="flex items-center justify-center cursor-pointer"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path d="M16 2C13.2311 2 10.5243 2.82109 8.22202 4.35943C5.91973 5.89777 4.12532 8.08427 3.06569 10.6424C2.00607 13.2006 1.72882 16.0155 2.26901 18.7313C2.80921 21.447 4.14258 23.9416 6.10051 25.8995C8.05845 27.8574 10.553 29.1908 13.2687 29.731C15.9845 30.2712 18.7994 29.9939 21.3576 28.9343C23.9157 27.8747 26.1022 26.0803 27.6406 23.778C29.1789 21.4757 30 18.7689 30 16C30 12.287 28.525 8.72601 25.8995 6.1005C23.274 3.475 19.713 2 16 2ZM24 17H11.85L17.43 22.573L16 24L8.00001 16L16 8L17.43 9.393L11.85 15H24V17Z" fill="black"/>
                    </svg>
                </div>
            </div>-->
            <div
                v-if="user"
                @click.stop="toggleSidebar(true)"
                class="h-16 w-8 inline-flex items-center md:justify-center justify-start rounded-md text-gray-200 text-2xl hover:text-red-500 focus:outline-none transition ease-in-out duration-150"
            >
                <span class="mdi mdi-menu text-white"></span>
            </div>
            <router-link v-if="user" to="/" class="rtb-title flex items-center text-xl font-bold">
                রিটার্ন ট্রিপ
            </router-link>
            <div class="flex gap-2 items-center">
                <div
                    v-if="user"
                    @click="viewNotification()"
                    class="notification-bell relative flex justify-center cursor-pointer"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                        <path d="M17.9383 22C17.9385 22.5046 17.7479 22.9906 17.4048 23.3605C17.0617 23.7305 16.5915 23.9572 16.0883 23.995L15.9383 24H13.9383C13.4337 24.0002 12.9478 23.8096 12.5778 23.4665C12.2078 23.1234 11.9812 22.6532 11.9433 22.15L11.9383 22H17.9383ZM14.9383 5C16.7533 4.99997 18.4973 5.70489 19.8026 6.96607C21.1078 8.22726 21.8721 9.94609 21.9343 11.76L21.9383 12V15.764L23.7603 19.408C23.8398 19.567 23.8796 19.7429 23.8763 19.9206C23.873 20.0984 23.8266 20.2727 23.7412 20.4286C23.6558 20.5845 23.5338 20.7174 23.3858 20.8158C23.2378 20.9143 23.0681 20.9754 22.8913 20.994L22.7763 21H7.10033C6.92249 21.0001 6.74729 20.957 6.58975 20.8745C6.4322 20.792 6.297 20.6725 6.19574 20.5264C6.09448 20.3802 6.03017 20.2116 6.00833 20.0351C5.98649 19.8586 6.00776 19.6795 6.07033 19.513L6.11633 19.408L7.93833 15.764V12C7.93833 10.1435 8.67582 8.36301 9.98858 7.05025C11.3013 5.7375 13.0818 5 14.9383 5Z" fill="white"/>
                    </svg>
                    <sup
                        v-if="notifications.length > 0"
                        class="count text-gray-700 text-sm mt-2 -ml-2"
                    >
                        {{ notifications.length > 9 ? "9+" : notifications.length }}
                    </sup>
                </div>
            </div>
        </div>
        <!-- Hamburger -->
    </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";
import AccountDropdown from "@/components/molecule/auth/AccountDropdown";
import {menus} from "@/data/menu";
import SwitchLang from "@/components/atom/SwitchLang";
import Form from "@/services/form";
import axios from "axios";
import {clearDeviceInterests} from "@/services/clearDeviceInterests";
import {directive} from "vue3-click-away";

export default {
    name: "Header",
    components: {
        AccountDropdown,
        SwitchLang,
    },

    data() {
        return {
            isLoggingOut: false,
            notifications: [],
            form: new Form(),
            navClass: [
                "px-4",
                "font-semibold",
                "hover:text-primary",
                "text-gray-700",
                "text-sm",
            ],
            mobileNav:
                "group flex items-center px-2 py-2 mb-2 text-base leading-6 font-medium rounded-md text-black focus:outline-none focus:bg-gray-700 transition ease-in-out duration-150",
            menus,
            signin: true,
        };
    },

    directives: {
        ClickAway: directive
    },

    computed: {
        ...mapGetters({
            user: "user/getUser",
            sidebarOpen: "getSidebarStatus",
        }),

        userType() {
            return this.user ? this.user?.type : false;
        },
    },

    methods: {
        ...mapMutations({
            setUserInfo: "user/setLoggedInUser",
            setDialogComponent: "setDialogComponent",
            setSidebarStatus: "setSidebarStatus",
            setDialog: "setDialog",
        }),
        navigate(link) {
            this.setSidebarStatus(false);
            this.$router.push(link);
        },
        handleDialog(name) {
            this.setSidebarStatus(false);
            this.setDialogComponent(name);
        },
        onClickAccountDropdown() {
            this.setSidebarStatus(false);
        },

        toggleSidebar(value) {
            this.setSidebarStatus(value);
        },
        async logOut() {
            localStorage.removeItem("trip_auth_user");
            localStorage.removeItem("token");
            localStorage.removeItem("imp_token");
            clearDeviceInterests();
            this.isLoggingOut = true;
            try {
                await this.form.post("auth/logout");
            } catch (err) {
                if (err.response) {
                }
            } finally {
                this.setUserInfo(null);
                this.$router.push("/signup");
            }
        },
        viewNotification() {
            this.$router.push("/notifications");
        },
        getNotifications(url) {
            axios.get(url).then((res) => {
                this.notifications = res.data.data.data;
            });
        },
        onClickAway() {
            if (this.sidebarOpen) {
                this.toggleSidebar(!this.sidebarOpen)
            }
        }
    }, //end of methods
    mounted() {
        let url = "notifications/unseen";
        if (this.user) {
            this.getNotifications(url);
        }
    },
    props: {
        logo: {
            default: "/images/aside-square-black.png",
        },
    },

    created() {
        this.setUserInfo();
    },

    watch: {
        $route: function () {
            this.setSidebarStatus(false);
            this.setDialog(false);
        },
    },
};
</script>

<style scoped lang="scss">
.rtb-header {
    background: #fff;
    //@apply shadow-lg md:hidden block;
    font-family: 'Noto Sans Bengali',serif;
}

.signin-signup-wrapper {
    min-width: 130px;
    display: grid;
    justify-content: flex-end;
}

.header-signin-signup {
    border-color: #ff4365;
    min-width: 120px;
}

.colored-primary {
    color: #ff4365;
}

.signup {
    font-weight: bold;
}

.signup-section {
    font-size: 12px !important;
    gap: 5px;
    bottom: -20px !important;
}

.vertical-menu-dots {
    max-height: 24px;
    max-width: 24px;
}


.vsc-popup-button--default {
    background-color: #69c157 !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
}

.vsc-popup {
    bottom: 50px !important;
}

.vsc-popup-button {
    height: 40px !important;
    width: 40px !important;
}

.vsc-popup-button:focus,
.vsc-popup-button:hover {
    box-shadow: none !important;
}

.max-width {
    max-width: 1260px;
}

.contact-us p {
    border-bottom: 3px solid #000;
    max-width: fit-content;
    padding-right: 10px;
    padding-bottom: 2px;
}

.mobile-header {
    font-family: 'Noto Sans Bengali',serif;
    .rtb-title {
        color: #ffffff;
    }
}
.mobile-header-bg-white {
    background: #F8FAFC;
}
.mobile-header-bg-black {
    background: #000000;
}
.mid-line {
    height: 2px;
    width: 100%;
    margin: 0 10px;
    border-radius: 10px;
    background: #BBC6D0;
}

.user-name-email {
    color: #3A3A3A;

    .email {
        font-size: 12px;
        font-weight: 400;
    }
}

.title {
    font-family: 'Noto Sans Bengali', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #1A1A1A;
}

.menu-item {
    display: flex;
    padding: 8px 12px;
    align-items: center;
    gap: 6px;
    border-radius: 4px;
}

.logout-rtb {
    border-radius: 10px;
    background: #000000;
}

@media (min-width: 640px) {
    .notification-bell svg {
        height: 30px;
        width: 30px;

        path {
            fill: gray;
        }
    }
}
</style>
